var App = App || {};

App.ComponentSubPages = (function ($) {
    'use strict';

    function EqualHeightCards() {
    var $cards = $('.component-subpages .subpage-card');
 
    
    $cards.css('height', 'auto');
 
   
    if ($(window).width() >= 992) {
        var maxHeight = 0;
 
        $cards.each(function () {
            maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });
 
        $cards.height(maxHeight);
    }
}
return {
        EqualHeightCards: EqualHeightCards
    };

})(jQuery);

$(function () {
    App.ComponentSubPages.EqualHeightCards();
});